"use client";

import { useEffect, useState } from "react";
import Link from "next/link";

const COOKIE_NAME = "cookieConsent";
const COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 365; // 1 year

function hasConsented(): boolean {
  return document.cookie
    .split("; ")
    .some((c) => c.startsWith(`${COOKIE_NAME}=`));
}

function setConsentCookie() {
  document.cookie = `${COOKIE_NAME}=true; max-age=${COOKIE_MAX_AGE_SECONDS}; path=/; SameSite=Lax`;
}

export function CookieNotification() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const id = requestAnimationFrame(() => {
      if (!hasConsented()) setVisible(true);
    });
    return () => cancelAnimationFrame(id);
  }, []);

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 z-50 flex w-full items-center justify-center border-t border-t-headings/10 bg-paper p-4 text-sm text-headings/90">
      <p className="m-0">
        This website uses cookies to ensure you get the best experience on our
        website.
        <Link
          href="/cookies-policy"
          className="ml-2 text-xs font-bold text-primary underline"
        >
          Cookies Policy
        </Link>
      </p>
      <button
        type="button"
        onClick={() => {
          setConsentCookie();
          setVisible(false);
        }}
        className="ml-4 rounded bg-primary px-5 py-1 text-sm font-semibold text-paper"
      >
        Accept
      </button>
    </div>
  );
}
